import { getKeys, inferRecord } from "@base/util/TypeUtil";

interface IKederInfo {
  articleNumber: string;
  railArticles: string[];
}

export const kederInfos = inferRecord<IKederInfo>()({
  "5": { articleNumber: "00E13001945", railArticles: [] },
  "5.5": { articleNumber: "00E13001946", railArticles: [] },
  "7.5": { articleNumber: "00E13001947", railArticles: ["00E13000282"] },
  // 10: { articleNumber: "00E13000807", railArticles: ["00E13000684"] },
  "13": { articleNumber: "00E13001948", railArticles: ["00E13000684"] },
});
export const kederSizes = getKeys(kederInfos).sort((a, b) => +a - +b);

export type KederSize = keyof typeof kederInfos;
export type KederSailMountType = "nextToRail" | "inRail";
